import * as React from 'react'

const ContentGuidelinesIcon = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 9.88889V2.11111C1 1.81643 1.1317 1.53381 1.36612 1.32544C1.60054 1.11706 1.91848 1 2.25 1H10.625C10.7245 1 10.8198 1.03512 10.8902 1.09763C10.9605 1.16014 11 1.24493 11 1.33333V8.61889M2.25 8.77778H11M2.25 11H11"
      stroke="#545454"
      strokeLinecap="round"
    />
    <path
      d="M2.25 11.0001C1.91848 11.0001 1.60054 10.883 1.36612 10.6746C1.1317 10.4662 1 10.1836 1 9.88894C1 9.59426 1.1317 9.31164 1.36612 9.10327C1.60054 8.8949 1.91848 8.77783 2.25 8.77783"
      stroke="#545454"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.125 3.22217H7.875" stroke="#545454" strokeLinecap="round" />
  </svg>
)

export default ContentGuidelinesIcon
